import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { mask } from 'remask';
import moment from 'moment';
import 'moment/locale/pt-br';
import axios from 'axios';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';

const useStyles = (theme) => ({
  root: {
    width: '95%',
  },
  container: {
    height: '100vh',
  },
  button: {
    margin: theme.spacing(1),
  },
  selectTipo: {
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
});

class ClientesComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    moment.locale('pt-br');
  }

  state = {
    clientes: [],
    segmentos: [],
    columns: [
      { id: 'nome', label: 'Nome', minWidth: 140 },
      { id: 'cnpj', label: 'CNPJ', minWidth: 180 },
      { id: 'tributacao', label: 'Tributação', minWidth: 140 },
      { id: 'codigoSimples', label: 'Código Simples', minWidth: 60 },
      { id: 'loginPrefeitura', label: 'Login Prefeitura', minWidth: 140 },
      { id: 'senhaPrefeitura', label: 'Senha Prefeitura', minWidth: 140 },
    ],
    busca: '',
    cliente: this.cleanCliente(),
    ready: false,
    limit: 10,
    offset: 0,
    count: 0,
    assinantes: false,
    textoSwitch: 'Todos Clientes',
    textoSwitchDetalhe: 'Dados Gerais',
  };

  cleanCliente() {
    return {
      cpf: '',
      rg: '',
      telefone: '',
      perfil: 'COMUM',
      EnderecoUsuario: this.cleanEnderecoUsuario(),
      UsuarioEmpresa: this.cleanUsuarioEmpresa(),
    };
  }

  cleanEnderecoUsuario() {
    return {
      cep: '',
    };
  }

  cleanUsuarioEmpresa() {
    return {
      Empresa: {
        cnpj: '',
        cep: '',
      },
    };
  }

  componentWillMount() {
    this.atualizarClientes('', 10, 0, false);

    this.axios.get(`${environment}/segmentosatuacao`).then((res) => {
      const segmentos = res.data;
      this.setState({ segmentos });
      this.setState({ ready: true });
    });
  }

  atualizarClientes = async (nome, limit, offset, assinantes) => {
    console.log(
      `${environment}/clientes?nome=${nome}&limit=${limit}&offset=${offset}&assinantes=${assinantes}`
    );
    this.axios
      .get(
        `${environment}/clientes?nome=${nome}&limit=${limit}&offset=${offset}&assinantes=${assinantes}`
      )
      .then((res) => {
        console.log(res.data);
        const clientes = res.data.rows;
        const { count } = res.data;
        this.setState({ clientes });
        this.setState({ count });
        this.setState({ ready: true });
      });
  };

  handleBusca = async (event) => {
    this.setState({ ready: false });
    this.setState({ busca: event.target.value });
    this.setState({ offset: 0 });
    this.setState({ limit: 10 });
    this.atualizarClientes(event.target.value, 10, 0, this.state.assinantes);
  };

  handleAssinantes = () => {
    const assinantes = !this.state.assinantes;
    const textoSwitch = assinantes ? 'Apenas Assinantes' : 'Todos Clientes';
    this.setState({ offset: 0 });
    this.setState({ limit: 10 });
    this.setState({ assinantes, textoSwitch });
    this.atualizarClientes(this.state.busca, 10, 0, assinantes);
  };

  handleChangeCepEmpresa = async (event) => {
    const obj = this.state.cliente;
    obj.UsuarioEmpresa.Empresa.cep = event.target.value;
    this.setState({ cliente: obj });
    if (event.target.value.length === 8) {
      await axios
        .get(`https://viacep.com.br/ws/${event.target.value}/json/`)
        .then((res) => {
          obj.UsuarioEmpresa.Empresa.bairro = res.data.bairro;
          obj.UsuarioEmpresa.Empresa.complemento = res.data.complemento;
          obj.UsuarioEmpresa.Empresa.cidade = res.data.localidade;
          obj.UsuarioEmpresa.Empresa.logradouro = res.data.logradouro;
          obj.UsuarioEmpresa.Empresa.uf = res.data.uf;
          obj.UsuarioEmpresa.Empresa.numero = '';
          this.setState({ cliente: obj });
        })
        .catch((err) => {
          obj.UsuarioEmpresa.Empresa.bairro = '';
          obj.UsuarioEmpresa.Empresa.complemento = '';
          obj.UsuarioEmpresa.Empresa.cidade = '';
          obj.UsuarioEmpresa.Empresa.logradouro = '';
          obj.UsuarioEmpresa.Empresa.uf = '';
          obj.UsuarioEmpresa.Empresa.numero = '';
          this.setState({ cliente: obj });
        });
    }
  };

  handleChangeCepCliente = async (event) => {
    const obj = this.state.cliente;
    obj.EnderecoUsuario.cep = event.target.value;
    this.setState({ cliente: obj });
    if (event.target.value.length === 8) {
      await axios
        .get(`https://viacep.com.br/ws/${event.target.value}/json/`)
        .then((res) => {
          obj.EnderecoUsuario.bairro = res.data.bairro;
          obj.EnderecoUsuario.complemento = res.data.complemento;
          obj.EnderecoUsuario.cidade = res.data.localidade;
          obj.EnderecoUsuario.logradouro = res.data.logradouro;
          obj.EnderecoUsuario.uf = res.data.uf;
          obj.EnderecoUsuario.numero = '';
          this.setState({ cliente: obj });
        })
        .catch((err) => {
          obj.EnderecoUsuario.bairro = '';
          obj.EnderecoUsuario.complemento = '';
          obj.EnderecoUsuario.cidade = '';
          obj.EnderecoUsuario.logradouro = '';
          obj.EnderecoUsuario.uf = '';
          obj.EnderecoUsuario.numero = '';
          this.setState({ cliente: obj });
        });
    }
  };

  handleChangePage = async (event, newPage) => {
    this.setState({ offset: newPage });
    this.atualizarClientes(
      this.state.busca,
      this.state.limit,
      newPage,
      this.state.assinantes
    );
  };

  handleChangeRowsPerPage = async (event) => {
    this.setState({ limit: event.target.value });
    this.atualizarClientes(
      this.state.busca,
      event.target.value,
      this.state.offset,
      this.state.assinantes
    );
  };

  handleChangePerfil = () => {
    const cl = this.state.cliente;
    if (cl.perfil === 'ADMIN') cl.perfil = 'COMUM';
    else cl.perfil = 'ADMIN';
    this.setState({ cliente: cl });
  };

  render() {
    const { classes } = this.props;
    const CNPJPattern = ['99.999.999/9999-99'];
    const unmaskCNPJ = ['99999999999999'];
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingTop: 20,
        }}
      >
        <h1>Clientes Detalhados</h1>
        <Paper className={classes.root}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.assinantes}
                    onChange={this.handleAssinantes}
                    color="primary"
                  />
                }
                label={this.state.textoSwitch}
              />
            </FormGroup>
            <TextField
              id="busca"
              label="Busca"
              value={this.state.busca}
              onChange={this.handleBusca}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <Collapse in={this.state.ready}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.clientes.map((c) => {
                  const estilo = c.ativo ? {} : { color: '#ffb42e' };
                  const cnpj = c.UsuarioEmpresa
                    ? mask(c.UsuarioEmpresa.Empresa.cnpj, CNPJPattern)
                    : '';
                  const tributacao = c.UsuarioEmpresa
                    ? c.UsuarioEmpresa.Empresa.TipoTributacao.nome
                    : '';
                  const codigoSimples = c.UsuarioEmpresa
                    ? c.UsuarioEmpresa.Empresa.codigo_simples
                    : '';
                  const loginPrefeitura = c.UsuarioEmpresa
                    ? c.UsuarioEmpresa.Empresa.EmpresaUsuarioNFE
                      ? c.UsuarioEmpresa.Empresa.EmpresaUsuarioNFE
                          .login_insc_municipal
                      : ''
                    : '';
                  const senhaPrefeitura = c.UsuarioEmpresa
                    ? c.UsuarioEmpresa.Empresa.EmpresaUsuarioNFE
                      ? c.UsuarioEmpresa.Empresa.EmpresaUsuarioNFE
                          .senha_insc_municipal
                      : ''
                    : '';
                  console.log(c);
                  return (
                    <TableRow key={c.id}>
                      <TableCell component="th" scope="row" style={estilo}>
                        {c.nome}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {cnpj}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {tributacao}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {codigoSimples}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {loginPrefeitura}
                      </TableCell>
                      <TableCell component="th" scope="row" style={estilo}>
                        {senhaPrefeitura}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.limit}
              page={this.state.offset}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Collapse>
          <Collapse in={this.state.ready === false}>
            <CircularProgress className={classes.loading} />
          </Collapse>
        </Paper>
      </div>
    );
  }
}

export default withStyles(useStyles)(ClientesComponent);
